import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	skip: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.skip',
		defaultMessage: 'Skip',
		description:
			'Skip button in the spotlight tour card shown for customers using AI issue search.',
	},
	next: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.next',
		defaultMessage: 'Next',
		description:
			'Next button in the spotlight tour card shown for customers using AI issue search.',
	},
	done: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.done',
		defaultMessage: 'Done',
		description:
			'Done button in the spotlight tour card shown for customers using AI issue search.',
	},
	globalTourHeading: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-heading',
		defaultMessage: 'Use AI to find issues faster',
		description: 'Heading of the spotlight tour card shown for customers using AI issue search.',
	},
	globalTourBody: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-body',
		defaultMessage:
			'Search for issues with Atlassian Intelligence instead of coming up with complex queries.',
		description: 'Body of the spotlight tour card shown for customers using AI issue search.',
	},
	tourHeading: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.tour-heading',
		defaultMessage: 'Just start typing',
		description: 'Heading of the spotlight tour card shown for customers using AI issue search.',
	},
	tourBody: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.tour-body',
		defaultMessage: 'The more detail you give us, the more accurate the search results.',
		description: 'Body of the spotlight tour card shown for customers using AI issue search.',
	},
	backButtonLabel: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.back-button-label',
		defaultMessage: 'Back - Exit Atlassian Intelligence and return to Basic or JQL search',
		description: 'Label for the "Back" button to exit AI search',
	},
	jqlTooComplex: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-too-complex',
		defaultMessage:
			'This query is too complex for Basic mode. Atlassian Intelligence has switched to JQL mode to improve results.',
		description:
			'Info message displayed to the user when JQL returned is too complex for basic mode',
	},
});
